<template>
  <section class="calendar">
    <div class="sign_main">
      <div class="sign_succ_calendar_title">
        <div class="calendar_month_span">{{dateTitle}} (本月已签到{{signNum}}次)</div>
      </div>
      <div class="sign">
        <ul class="week-th">
          <li>日</li>
          <li>一</li>
          <li>二</li>
          <li>三</li>
          <li>四</li>
          <li>五</li>
          <li>六</li>
        </ul>
        <ul class="month-body">
          <li v-for="day in firWeek"></li>
          <li v-for="day in days" :class="isSign(day)?'on':''">{{day}}</li>
          <li v-for="day in preDays"></li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
  export default{
    props: ['signDays'],
    data(){
      return {
        dateTitle: '',
        signNum: 0,
        days: 0,
        firWeek: 0,
        preDays: 0,
        Date: []
      }
    },
    created(){
      this.Date = new Date();
    },
    watch: {
      signDays(){
        this.getDateList(new Date());
      }
    },
    mounted(){
      this.getDateList(this.Date);
    },
    methods: {
      getDateList(date){
        const curMonth = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        this.dateTitle = date.getFullYear() + '年' + curMonth + '月';
        // 本月第一天星期  firWeek：4
        this.firWeek = new Date(date.getFullYear(), curMonth - 1, 1).getDay();
        // 获取本月天数 31
        this.days = new Date(date.getFullYear(), curMonth, 0).getDate();
        // 下月同一星期
        this.preDays = 7 - (this.firWeek + this.days) % 7;
        // 本月签到次数
        this.signNum = this.signDays.length > 0 ? this.signDays.split(',').length : 0;
      },
      isSign(day){
        const array = this.signDays.split(',');
        const matched = array.filter(i => {
          return i == day;
        });
        if (matched.length === 0) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
</script>
<style>
  .calendar {
    position: absolute;
    z-index: 9999;
    left: 250px;
    width: 200px;
  }

  .sign_main {
    width: 100%;
    background-color: #FBFEFE;
    border-top: 1px solid #e3e3e3;
    font-family: "Microsoft YaHei", SimHei;
    display: block;
  }

  .calendar_month_span {
    display: inline;
    line-height: 30px;
    padding-left: 20px;
    font-size: 12px;
    color: #656565;
  }

  .sign_succ_calendar_title {
    width: 198px;
    border-left: 1px solid #e3e3e3;
    border-right: 1px solid #e3e3e3;
    background: #fff;
  }

  .sign {
    width: 100%;
  }

  .sign .week-th, .sign .month-body {
    width: 100%;
    float: left;
    background-color: #fff;
  }

  .sign .week-th li, .sign .month-body li {
    float: left;
    width: calc(100% / 7 - 1px);
    height: 24px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
    border: 1px solid #ddd;
    border-left: none;
  }

  .sign .month-body li {
    border-top: none;
  }

  .sign .week-th li:last-child {
    border-right: none;
  }

  .singer_r_img span {
    margin-left: 14px;
    font-size: 16px;
    font-family: 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif !important;
    font-weight: 700;
    color: #165379;
  }

  .sign .on {
    background: url(../../../assets/images/sign_have.gif) no-repeat center;
  }


</style>



// WEBPACK FOOTER //
// calendar.vue?0bc70978